export default __webpack_public_path__ + "static/media/central_andes_2_1.0cb9539d.jpg";